
import styled from "styled-components";
import TifynLogo from "../assets/images/tifyn-logo.png"
import { TifynFooter } from "@tiffin/components";

export const Error = styled(BaseError)`
  display: flex;
  flex-direction: column;
  height: 100%;

  .page {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    text-align: center;
    padding: 40px;

    .logo {
      height: 40px;
    }
  }
`

interface IError {
  className?: string
}

function BaseError({className}: IError) {

  return (
    <div className={className}>
      <div className="page">
        <img className="logo" alt={"Tifyn Logo"} src={TifynLogo} />
        <h3>Sorry, we could not find the store you are looking for</h3>
      </div>
      <TifynFooter
        logoAlt="Tifyn Logo"
        logoSrc={TifynLogo}
      />
    </div>
  )
}